module.exports = __webpack_public_path__ + "public/img/yichuli.1566ef35.png";